import axios from 'axios';

export const imageUpload = (url, { image, type }) => {
  return axios.put(url, image, {
    headers: {
      'Content-Type': `${type}`
    }
  });
};
